<template>
  <b-container class="communes">
    <h1 class="titre">Prochains passages<br/>{{ this.$route.params.idZone }}</h1>
    <h2 class="selection_arret">Sélectionnez l'arrêt de votre choix :</h2>
    <div class="perturbation-section alert-warning" v-if="(infoTraficLine && infoTraficLine.length > 0)">
      <div class="perturbation-content">
        <div class="perturbation-title">
          <a href="https://www.evad.fr/trafic/"
             target="_blank"
             rel="noopener noreferrer"
             class="info-badge"
             :aria-label="'Informations de trafic'"
             :title="'Informations de trafic'">
            <span aria-hidden="true">!</span>
            <span class="sr-only">Info trafic</span>
          </a>
          <p class="perturbation-message">Perturbations en cours sur la ligne : {{ routeShortName }}</p>
        </div>
        <p class="info-trafic-link">
          <a href="https://www.evad.fr/trafic/" target="_blank" rel="noopener noreferrer" class="fst-italic">Consulter les détails des perturbations sur le site d'EVAD →</a>
        </p>
      </div>
    </div>
    <div v-if="infoTraficLoadError" class="text-muted" style="margin-top:0.5rem">
      Erreur lors du chargement des informations trafic — vous pouvez consulter
      <a href="https://www.evad.fr/trafic/" target="_blank" rel="noopener noreferrer">EVAD</a>.
    </div>
    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="liste_arret row">
      <div v-for="stop in stops" :key="stopId" class="col-lg-3 col-md-4 col-12">
        <b-btn :to="{name: 'ProchainPassages', query: {stopIds: stop.ids}}" class="arret">
          <span class="nom_arret">{{ stop.name }}</span>
        </b-btn>
      </div>
    </div>
    <div v-if="stops !== null && stops.length === 0" class="pas-de-passages">
      <div class="pas-de-passages">
        <span>{{messageErreurListArrets}}</span>
        <button class="retour" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i>  RETOUR
        </button>
      </div>
    </div>
  </b-container>
</template>

<script>
import router from '../router'

export default {
  name: 'Arrets',
  data () {
    return {
      stops: null,
      loading: false,
      messageErreurListArrets: '',
      infoTraficLine: [],
      infoTraficLoadError: false,
      routeShortName: ''
    }
  },
  methods: {
    goToProchainPassageSiUnSeulArret: function () {
      if (this.stops && this.stops.length === 1) {
        router.replace('arret=' + this.stops[0])
      }
    }
  },

  mounted () {
    this.loading = true
    this.infoTraficLine = []
    this.axios.get('/gtfs/routes')
      .then((res) => {
        const route = (res.data || []).find(r => r.route_id === this.$route.params.routeId)
        if (route) {
          this.routeShortName = route.route_short_name
        }
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des routes:', error)
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des routes:', error)
      })
    this.axios.get('/listStops/' + this.$route.params.routeId)
        .then((succes) => {
          if (204 === succes.status) {
            this.stops = []
            this.loading = false
            this.messageErreurListArrets = "Il n'y a pas d'horaires dans ce sens, à cette date et à cet horaire correspondant à votre demande"
            return
          }
          this.stops = succes.data
          this.loading = false
          this.goToProchainPassageSiUnSeulArret()
        })
        .catch((error) => {
          this.stops = []
          this.loading = false
          this.messageErreurListArrets = 'Erreur lors du chargement des arrêts pour cette ligne.'
          console.error('ERREUR', error)
        })
    this.axios.get('/info-trafic/' + this.$route.params.routeId)
      .then((succes) => {
        if (succes.data) {
          this.infoTraficLine = succes.data
        }
      })
      .catch((error) => {
        this.infoTraficLoadError = true
        console.error('ERREUR', error)
      })
    }
  }
</script>

<style lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.communes {
  text-align: center;
  margin-top: 3rem;

  .titre {
    color: $secondcolor;
    font-family: $titlefont;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .perturbation-section {
    margin-bottom: 1.5rem;
    padding: 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    @include media-breakpoint-down(sm) {
      margin: 1rem 0;
      padding: 1.2rem;
    }
    @include media-breakpoint-up(md) {
      padding: 1.5rem 2rem;
      margin: 0 auto 1.5rem auto;
    }
  }

  .perturbation-content {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .perturbation-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;

    span {
      font-family: $titlefont;
    }
  }

  .perturbation-message {
    margin: 0;
    font-size: 0.95rem;
    color: #495057;
    line-height: 1.5;
  }

  .info-trafic-link {
    font-style: italic;
    margin: 0.5rem 0 0 0;
    font-size: 0.9rem;
    color: #6c757d;

    a {
      color: #0066cc;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.2s ease;
      border-bottom: 1px solid transparent;

      &:hover {
        color: #0052a3;
        border-bottom: 1px solid #0052a3;
      }
    }
  }

  .selection_arret {
    color: $firstcolor;
    font-family: $textfont;
    font-size: 30px;
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $secondcolor;
      width: 6rem;
      height: 6rem;
    }
  }
  .info-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    font-weight: 700;
    font-size: 1rem;
    text-decoration: none;
    transition: background-color 0.2s ease;
    vertical-align: middle;

    &:hover {
      background-color: #c82333;
      color: white;
    }
  }


  .pas-de-passages {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    min-height: 60vh;
    width: 90%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;

    .retour {
      margin-top: 20px;
      padding: 10px 30px;
      background: $firstcolor;
      color: white;
      border: none;
      border-radius: 30px;
      cursor: pointer;
    }
  }

  .liste_arret {
    justify-content: center;
    margin-top: 2rem;
    display: flex;

    .arret {
      height: 100px;
      border: 2px solid $secondcolor;
      background-color: white;
      border-radius: 10px;
      color: $secondcolor;
      font-family: $titlefont;
      font-size: 20px;
      margin: 15px 0;
      padding: 1rem;
      text-decoration: none;
      display: flex;
      @include media-breakpoint-between(md, lg) {
        height: 125px;
      }

      .nom_arret {
        margin: auto;
      }
    }

    .arret:hover {
      background-color: $secondcolor;
      color: white;
    }
  }
  .pas-de-passages {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    min-height: 60vh;
    width: 90%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    .div-oops{
      align-items: center;
      .svg-oops{
        height: 10vh;
        width: auto;
        @include media-breakpoint-down(sm) {
          font-size: 5vh !important;;
        }
      }
      span{
        font-size: 10vh;
        @include media-breakpoint-down(sm) {
          font-size: 5vh !important;;
        }
      }
    }

    .retour{
      margin-top: 20px;
      padding: 10px 30px;
      background: $firstcolor;
      color: white;
      border: none;
      border-radius: 30px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Arrets.vue